module.exports = __webpack_public_path__ + "img/h5_banner02.f66690e1.webp";